/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { OrderCopyCargoBySeparate } from './order_copy_cargo_by_separate'
import type { OrderCopyCargoByTotal } from './order_copy_cargo_by_total'
/**
 * Данные о грузе
 */
export type OrderCopyCargo = {
  /**
   * Способ указания информации о грузе
   */
  type: OrderCopyCargo.type
  /**
   * Информация о грузе в виде отдельных грузомест
   */
  cargoBySeparate: null | Array<OrderCopyCargoBySeparate>
  /**
   * Информация о грузе в виде общего веса и объема
   */
  cargoByTotal: null | OrderCopyCargoByTotal
}
export namespace OrderCopyCargo {
  /**
   * Способ указания информации о грузе
   */
  export enum type {
    SEPARATE = 'separate',
    TOTAL = 'total'
  }
}
